import React, { memo } from 'react';
import { IconButton } from '../button';
import { ResetIcon } from '../icons';
import { Icon } from '../icon';
export const ClearButton = /*#__PURE__*/memo(({
  onClick
}) => (/*#__PURE__*/React.createElement(IconButton, {
  size: "m",
  label: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435 \u043F\u043E\u043B\u044F",
  onClick: onClick,
  tabIndex: -1,
  variant: "secondary",
  withExtraClickZone: true
}, /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement(ResetIcon, null)))));